export enum LayoutTypesEnum {
    vertical,
    horizontal
}
